export const VAR_STATUS_UPLOADED = 1;
export const VAR_STATUS_SUBMITTED = 2;
export const VAR_STATUS_APPROVED = 3;
export const VAR_STATUS_UNAPPROVED = 4;
export const VAR_STATUS_CANCELLED = 5;
export const VAR_STATUS_REFERBACKSD = 6;
export const VAR_STATUS_FINALISED = 7;

export const VAR_STATUS_COLOR_APPROVED = "#00833D" //green
export const VAR_STATUS_COLOR_UPLOADED = "#F26A21" //orange
export const VAR_STATUS_COLOR_SUBMITTED = "#F26A21" //orange
export const VAR_STATUS_COLOR_UNAPPROVED = "#E2231A" //red
export const VAR_STATUS_COLOR_CANCELLED = "#E2231A" //red
export const VAR_STATUS_COLOR_REFERBACKSD = "#E2231A" //red
export const VAR_STATUS_COLOR_FINALISED = "#1CABE2" //blu